// extracted by mini-css-extract-plugin
module.exports = {"detailBox":"style_detailBox__2YC43","highlight":"style_highlight__2BS-e","hover":"style_hover__1c5Pl","action":"style_action__uy49r"};